import { Injectable } from '@angular/core';
import { Application, Layout } from './settings';

@Injectable()
export class SettingsService {

  public app: Application;
  public layout: Layout;

  constructor() {
    this.app = new Application();
    this.app.name = 'AutoLoop XRM';
    this.app.description = 'Full Suite CRM';

    this.layout = new Layout();
    this.layout.isCollapsed = false;
  }

}
